import * as THREE from 'three';
import starGlowVert from '../shaders/starGlow.vert?raw';
import starGlowFrag from '../shaders/starGlow.frag?raw';

/**
 * Create a single-point "marker star" rendered with the same shader as
 * the background HYG catalog (StarField).
 *
 * Used for non-interactive visual markers - e.g., Jupiter, placed at its
 * real position in the sky as a reference point for finding Europa.
 * Because it uses the same shader as the background stars, it visually
 * blends in with them: it looks like one more bright cataloged star, not
 * like a "click me" interactive sprite.
 */
export function createMarkerStar(position, colorHex, size) {
  const positions = new Float32Array([position.x, position.y, position.z]);
  const c = new THREE.Color(colorHex);
  const colors = new Float32Array([c.r, c.g, c.b]);
  const sizes = new Float32Array([size]);

  const geometry = new THREE.BufferGeometry();
  geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
  geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));
  geometry.setAttribute('size', new THREE.BufferAttribute(sizes, 1));

  const material = new THREE.ShaderMaterial({
    vertexShader: starGlowVert,
    fragmentShader: starGlowFrag,
    transparent: true,
    depthWrite: false,
    blending: THREE.AdditiveBlending,
  });

  const points = new THREE.Points(geometry, material);
  points.renderOrder = -1; // same as the background star field
  return points;
}
